export default __webpack_public_path__ + "static/viv3-32834a2478740ae213651a7fc9e6b1c2.png";